import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Wordmark from "./Wordmark";

const LINKS = [
  { to: "/", label: "Home", id: "nav-link-home" },
  { to: "/about", label: "About", id: "nav-link-about" },
  { to: "/contact", label: "Contact", id: "nav-link-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-ink/90 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 lg:h-20 lg:px-8">
        <Link to="/" data-testid="nav-wordmark" aria-label="GSMG INVESTMENTS — home">
          <Wordmark />
        </Link>

        <nav className="hidden items-center gap-9 lg:flex" aria-label="Primary">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={l.id}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${
                  isActive ? "text-sky-300" : "text-slate-300 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link
          to="/contact"
          data-testid="nav-enquire-button"
          className="hidden rounded-md bg-brand px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-brand/20 transition-all hover:bg-sky-400 hover:shadow-sky-500/25 active:scale-[0.98] lg:inline-flex"
        >
          Enquire Now
        </Link>

        <button
          type="button"
          data-testid="nav-mobile-toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          onClick={() => setOpen((o) => !o)}
          className="grid h-10 w-10 place-items-center rounded-md border border-white/15 text-white lg:hidden"
        >
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-ink px-5 pb-6 pt-3 lg:hidden">
          <nav className="flex flex-col" aria-label="Mobile">
            {LINKS.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`${l.id}-mobile`}
                className={({ isActive }) =>
                  `border-b border-white/5 py-3.5 text-base font-medium ${
                    isActive ? "text-sky-300" : "text-slate-200"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <Link
            to="/contact"
            data-testid="nav-enquire-button-mobile"
            className="mt-5 inline-flex w-full items-center justify-center rounded-md bg-brand px-5 py-3 text-sm font-semibold text-white"
          >
            Enquire Now
          </Link>
        </div>
      )}
    </header>
  );
}
